import React, { useEffect, useState } from "react";
import { ArrowUpRight, CalendarDays } from "lucide-react";
import axios from "axios";
import { Link } from "react-router-dom";

function BlogSection() {
  const [blogs, setBlogs] = useState([]);

  const fetchData = async () => {
    try {
      const res = await axios.get("https://goawin.xyz/api/domain/blogs", {
        withCredentials: true,
      });

      setBlogs(res.data.data || []);
    } catch (err) {
      console.log("Server Error");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <section className="relative py-16 px-4 sm:px-6 lg:px-16 overflow-hidden bg-white dark:bg-[#050505]">
      {/* BACKGROUND */}
      <div className="absolute top-0 left-0 w-[300px] md:w-[500px] h-[300px] md:h-[500px] bg-primary/10 blur-[120px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[300px] md:w-[500px] h-[300px] md:h-[500px]bg-primary/10 blur-[120px] rounded-full" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* HEADER */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-black text-gray-900 dark:text-white">
            Latest{" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">
              Blogs
            </span>
          </h2>

          <p className="myparagraph  text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Insights, strategies and updates about design, development and
            digital growth.
          </p>
        </div>

        {/* GRID */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.slice(0, 3).map((blog, index) => (
            <div
              key={index}
              className="group relative p-5 md:p-6 rounded-2xl border border-black/5 dark:border-white/10 bg-white/70 dark:bg-white/5 backdrop-blur-xl hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(254,120,83,0.15)] transition-all duration-300"
            >
              {/* TAG */}
              <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-primary/10 text-primary mb-4">
                {blog.category.name}
              </div>

              {/* TITLE */}
              <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white leading-snug">
                {blog.title}
              </h3>

              {/* DESC */}
              <div
                className="mt-3 text-sm text-gray-600 dark:text-gray-400 line-clamp-3"
                dangerouslySetInnerHTML={{ __html: blog.content }}
              />

              {/* FOOTER */}
              <div className="mt-5 flex items-center justify-between">
                <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                  <CalendarDays className="w-4 h-4" />
                  {blog.createdAt}
                </div>

                <Link
                  to={`https://webxsecure.in/blog/${blog.slug}`}
                  className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:gap-2 transition-all"
                >
                  Read More
                  <ArrowUpRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogSection;
